import { LoginService } from "./LoginService.js";

export class ApiService {
    static async getTokenParam() {
        let tokenParam;

        try {
            let auth = await LoginService.getAuth();
            tokenParam = "token=" + auth.token;
        } catch (error) {
            throw { isError: true, error: error };
        }

        return tokenParam;
    }

    static async getToken() {
        let token;

        try {
            let auth = await LoginService.getAuth();
            token = auth.token;
        } catch (error) {
            throw { isError: true, error: error };
        }

        return token;
    }

    static isJson(response) {
        return (
            response.headers
                .get("content-type")
                ?.includes("application/json") ?? false
        );
    }

    static async get(url, params = undefined, apiVersion = null) {
        const token = await this.getToken();
        const urlParam = params ? `?${params}` : "";

        const response = await fetch(`${url}${urlParam}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                ...(apiVersion && { "X-API-Version": apiVersion }),
            },
        });

        if (response.ok) {
            if (this.isJson(response)) return await response.json();
        } else {
            throw { isError: true, error: response };
        }
    }

    static async post(url, body, params = undefined) {
        const token = await this.getToken();
        const urlParam = params ? `?${params}` : "";

        const response = await fetch(`${url}${urlParam}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            if (this.isJson(response)) return await response.json();
        } else {
            throw { isError: true, error: response };
        }
    }

    static async postFile(url, file) {
        const tokenParam = await this.getTokenParam();

        const formData = new FormData();
        formData.append("file", file);

        const response = await fetch(`${url}?${tokenParam}`, {
            method: "POST",
            body: formData,
        });

        if (response.ok) {
            if (this.isJson(response)) return await response.json();
        } else {
            throw { isError: true, error: response };
        }
    }

    static async put(url, body) {
        const token = await this.getToken();

        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            if (this.isJson(response)) return await response.json();
        } else {
            throw { isError: true, error: response };
        }
    }

    static async patch(url, body) {
        const token = await this.getToken();

        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            if (this.isJson(response)) return await response.json();
        } else {
            throw { isError: true, error: response };
        }
    }

    static async delete(url, body = {}) {
        const token = await this.getToken();

        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            return response;
        } else {
            throw { isError: true, error: response };
        }
    }
}
